import {useState, useRef, useEffect, useMemo} from 'react';

//components
import FiltersGroup from '../FiltersGroup/FiltersGroup';

//types
import {RfElementType} from '@stencil/hotels-cg-reducer/src/details/types';

//styles
import {
  WrapperDivUpsellHeader,
  WrapperDivUpsellFilter,
  ItemWrapperDivUpsell,
  TextStylingWrapperSpan,
} from './RoomSelectionHeader.styles';

const RoomSelectionHeaderUpsell = ({
  filterHeight = 0,
  isMultiRoom = false,
  upSellRoomTypeDD = null,
  currentFilters,
  setFilters,
  roomFilterGroup,
  colummnNames,
}) => {
  const [isScrolling, setIsScrolling] = useState<boolean>(false);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [currentFiltersCopy, setFiltersCopy] = useState<RfElementType[] | Array<any>>(
    currentFilters,
  );
  // const roomFilterGroup = useSelector(roomGroupFiltersDropdownSelector);

  const timeoutRef: {current: NodeJS.Timeout | null} = useRef(null);
  const scrollerRef = useRef<boolean | null>();
  scrollerRef.current = false;

  // to handle borders when navigation bar sticks to the top
  const scrollHandler = () => {
    clearTimeout(timeoutRef.current);
    if (!scrollerRef.current) {
      setIsScrolling(true);
      scrollerRef.current = true;
    }
    timeoutRef.current = setTimeout(() => {
      setIsScrolling(false);
      scrollerRef.current = false;
    }, 200);
  };

  const toggleFilter = () => {
    setShowFilters(!showFilters);
  };

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler);
    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  return (
    <>
      {roomFilterGroup?.length > 0 ? (
        <WrapperDivUpsellFilter>
          <FiltersGroup
            roomFilterGroup={roomFilterGroup}
            setFilters={setFilters}
            currentFilters={currentFilters}
            currentFiltersCopy={currentFiltersCopy}
            setFiltersCopy={setFiltersCopy}
          />
        </WrapperDivUpsellFilter>
      ) : null}
      <WrapperDivUpsellHeader>
        <ItemWrapperDivUpsell
          isCustomFlex={true}
          width={isMultiRoom ? '32%' : null}
          isUpsellWithMultiroom={isMultiRoom}
        >
          {upSellRoomTypeDD ? (
            upSellRoomTypeDD
          ) : (
            <TextStylingWrapperSpan>{colummnNames.type}</TextStylingWrapperSpan>
          )}
        </ItemWrapperDivUpsell>
        <ItemWrapperDivUpsell
          width={isMultiRoom ? '30.2%' : null}
          isUpsellWithMultiroom={isMultiRoom}
        >
          <TextStylingWrapperSpan>{colummnNames.options}</TextStylingWrapperSpan>
        </ItemWrapperDivUpsell>

        <ItemWrapperDivUpsell
          width={isMultiRoom ? '17.8%' : null}
          isUpsellWithMultiroom={isMultiRoom}
        >
          <TextStylingWrapperSpan>Price</TextStylingWrapperSpan>
        </ItemWrapperDivUpsell>
        {isMultiRoom && (
          <ItemWrapperDivUpsell
            width={isMultiRoom ? '25%' : null}
            isUpsellWithMultiroom={isMultiRoom}
          >
            <TextStylingWrapperSpan>Cart</TextStylingWrapperSpan>
          </ItemWrapperDivUpsell>
        )}
      </WrapperDivUpsellHeader>
    </>
  );
};

export default RoomSelectionHeaderUpsell;
